import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"grid-list-xl":""}},[_c(VLayout,{attrs:{"wrap":""}},_vm._l((_vm.categories),function(category){return _c('category-card',{key:category.title,attrs:{"value":category}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }